export const formatCurrency = (amount, symbol = '₹') => {
  return `${symbol}${parseFloat(amount).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const formatDateTime = (date) => {
  return new Date(date).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const getPaymentStatusColor = (status) => {
  const colors = {
    paid: 'success',
    partial: 'warning',
    due: 'danger',
    overdue: 'danger'
  };
  return colors[status] || 'info';
};

export const getInvoiceStatusColor = (status) => {
  const colors = {
    active: 'success',
    draft: 'warning',
    cancelled: 'danger'
  };
  return colors[status] || 'info';
};

export const downloadFile = (data, filename) => {
  const blob = data instanceof Blob ? data : new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const validateGSTNumber = (gst) => {
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  return gstRegex.test(gst);
};

export const validateEmail = (email) => {
  const emailRegex = /^\S+@\S+\.\S+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone);
};

export const calculateItemTotal = (item, taxType = 'excluded') => {
  if (taxType === 'included') {
    const total = Math.round((item.quantity * item.rate) * 100) / 100;
    const taxAmount = (total * item.gstRate) / (100 + item.gstRate);
    const roundedTaxAmount = Math.round(taxAmount * 100) / 100;
    const amount = Math.round((total - roundedTaxAmount) * 100) / 100;
    
    return {
      amount,
      taxAmount: roundedTaxAmount,
      total: Math.round((amount + roundedTaxAmount) * 100) / 100
    };
  } else {
    const amount = Math.round((item.quantity * item.rate) * 100) / 100;
    const taxAmount = (amount * item.gstRate) / 100;
    const roundedTaxAmount = Math.round(taxAmount * 100) / 100;
    
    return {
      amount,
      taxAmount: roundedTaxAmount,
      total: Math.round((amount + roundedTaxAmount) * 100) / 100
    };
  }
};

export const calculateInvoiceTotals = (items, isIGST, discount = 0, discountType = 'amount', taxType = 'excluded') => {
  let subtotal = 0;
  let totalTax = 0;
  let cgst = 0;
  let sgst = 0;
  let igst = 0;

  items.forEach(item => {
    const itemCalc = calculateItemTotal(item, taxType);
    subtotal += itemCalc.amount;
    totalTax += itemCalc.taxAmount;

    if (isIGST) {
      igst += itemCalc.taxAmount;
    } else {
      cgst += itemCalc.taxAmount / 2;
      sgst += itemCalc.taxAmount / 2;
    }
  });

  // Calculate discount amount
  let discountAmount = 0;
  if (discount > 0) {
    if (discountType === 'percentage') {
      discountAmount = (subtotal * discount) / 100;
    } else {
      discountAmount = discount;
    }
  }
  discountAmount = Math.round(discountAmount * 100) / 100;

  const calculatedTotal = subtotal + totalTax - discountAmount;
  const grandTotal = Math.round(calculatedTotal);
  const roundOff = Math.round((grandTotal - calculatedTotal) * 100) / 100;

  return {
    subtotal: Math.round(subtotal * 100) / 100,
    cgst: Math.round(cgst * 100) / 100,
    sgst: Math.round(sgst * 100) / 100,
    igst: Math.round(igst * 100) / 100,
    totalTax: Math.round(totalTax * 100) / 100,
    discountAmount,
    roundOff,
    grandTotal
  };
};
